<template>
<!-- 轮播图信息 -->
    <div class="YinshiOffcialwebsiteCarouselChart">
        <div><el-button type="primary" size="small" @click="add">添加</el-button></div> 
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="title" label="轮播图标题" ></el-table-column>
            <el-table-column prop="descr" label="轮播图描述" ></el-table-column>
            <el-table-column prop="imgUrl" label="图片链接" ></el-table-column>
            <el-table-column prop="targetUrl" label="跳转链接" ></el-table-column>
            <el-table-column prop="state" label="状态" width="140" >
                <template slot-scope="scope">
                    <!-- <el-tag type="danger" v-if="scope.row.state == 0">禁用</el-tag> -->
                    <!-- <el-tag type="" v-else>启用</el-tag> -->
                    <el-select v-model="scope.row.state" @change="stateFun(scope.row)" placeholder="请选择状态" class="statusWidthOne">
                        <el-option label="禁用" :value="0"></el-option>
                        <el-option label="启用" :value="1"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="190">
                <template slot-scope="scope" >
                    <el-button size="mini" @click="update(scope.row)">编辑</el-button>&ensp;
                    <el-popconfirm title="确定要删除吗？" icon="el-icon-info" icon-color="red" @confirm="deletes(scope.row.id)">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <div class="block">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="10"
                    layout="sizes, prev, pager, next"
                    :total="count">
                </el-pagination>
            </div>
        </div>
        <el-dialog :title="title+'轮播图'" :visible.sync="dialogFormVisible" class="personalInfo" width="29%">
            <div class="recruit">
                <el-form :model="objData" ref="downloadObj">
                    <el-form-item label="轮播图标题" class="labelWidth">
                        <el-input v-model="objData.title"></el-input>
                    </el-form-item>
                    <el-form-item label="轮播图描述" class="labelWidth">
                        <el-input v-model="objData.descr"></el-input>
                    </el-form-item>
                    <el-form-item label="图片链接" class="labelWidth">
                        <el-input v-model="objData.imgUrl"></el-input>
                    </el-form-item>
                    <el-form-item label="跳转链接" class="labelWidth">
                        <el-input v-model="objData.targetUrl"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="状态" class="labelWidth">
                        <el-select v-model="objData.state" placeholder="请选择状态" class="statusWidth">
                            <el-option label="禁用" :value="0"></el-option>
                            <el-option label="启用" :value="1"></el-option>
                        </el-select>
                    </el-form-item> -->
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitUpdate">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// listAllSwiperInfo        查询轮播图
// deleteSwiperInfo         删除轮播图
// saveSwiperInfo           新增轮播图
// updateSwiperInfo         修改轮播图
// switchState              修改轮播图状态【启用-禁用】
import { 
listAllSwiperInfo,
deleteSwiperInfo,
saveSwiperInfo,
updateSwiperInfo,
switchState,
} from '@/service'
export default {
    name: 'YinshiOffcialwebsiteCarouselChart',
    data() {
        return {
            // 分页
            pageObj:{
                page:1,
                pageSize:10,
            },
            // 总条数
            count:0,
            // 常见问题
            tableData: [],
            // 弹窗标题
            title:'',
            // 弹窗状态
            dialogFormVisible:false,
            // 要修改或者要增加
            objData:{
                id:'',
                title:'',
                descr:'',
                imgUrl:'',
                targetUrl:'',
                state:'',
            },
        };
    },

    mounted() {
        
    },
    watch:{
    },
    methods: {
        // 每页多少条
        handleSizeChange(val){
            this.pageObj.pageSize = val
            this.selectTableData()
        },
        // 页码
        handleCurrentChange(val){
            this.pageObj.page = val
            this.selectTableData()
        },
        // 查询
        async selectTableData(){
            let res = await listAllSwiperInfo({page:this.pageObj.page,pageSize:this.pageObj.pageSize});
            this.tableData = res.data
        },
        // 删除
        async deletes(id){
            let res = await deleteSwiperInfo(id);
            if(res.code == 200){
                this.$message({ message: '删除成功！', type: 'success' });
                this.selectTableData()
            }else{
                this.$message({message: '删除失败！',type: 'error'});
            }
        },
        // 修改
        async update(obj){
            this.dialogFormVisible = true
            Object.keys(obj).forEach(key1 => {
                Object.keys(this.objData).forEach(key2 => {
                    if(key1 == key2){
                        this.objData[key2] = obj[key1] 
                    }
                })
            })
            this.title = '修改'
        },
        // 新增弹窗
        add(){
            Object.keys(this.objData).forEach(key => {
                this.objData[key] = ''
            })
            this.title = '新增'
            this.dialogFormVisible = true

        },
        // 提交修改
        async submitUpdate(){
            let res;
            if(this.title == '修改'){
                res = await updateSwiperInfo(this.objData);
            }else{  //新增
                res = await saveSwiperInfo(this.objData);
            }
            if(res.code == 200){
                this.$message({ message: this.title+'成功！', type: 'success' });
                this.selectTableData()
                this.dialogFormVisible = false
            }else{
                if(res.data){
                    this.$message({message: res.data+'！',type: 'error'});
                }else{
                    this.$message({message: this.title+''+res.msg+'！',type: 'error'});
                }
            }
        },
        // 修改状态
        async stateFun(e){
            let res = await switchState({id:e.id});
            if(res.code == 200){
                this.$message({ message: '修改状态成功！', type: 'success' });
            }else{
                this.$message({message: '修改状态失败！',type: 'error'});
            }
            this.selectTableData()
        },
    },
    created(){
        this.$store.state.adminCurrentRouter = this.$route.path  //获取当前页面路由
        this.selectTableData()
    }
};
</script>

<style lang="scss">
.YinshiOffcialwebsiteCarouselChart .personalInfo .recruit{
    .el-form-item__label{
        width: 80px !important;
    }
    .el-form-item__content{
        width: 360px !important;
    }
    .el-dialog__body{
        padding: 10px 0px !important;
    }
}
.YinshiOffcialwebsiteCarouselChart .statusWidthOne{
    .el-input__inner{
        height: 30px !important;
    }
    .el-input__suffix{
        margin-top: 4px !important;
    }
}
</style>
<style lang="scss" scoped>
// 分页
.pagination{
    padding: 50px 270px 30px 270px;
    text-align: center;
}
</style>